export default __webpack_public_path__ + "static/media/BuiltInService.e36e1653.svg";